import React from "react";
import {GridBadgeProps} from "../../ImageGrid/props";

const GridBadge = ({ badge }: GridBadgeProps) => {
  if (!badge) {
    return null;
  }
  return (
    <div className="image-grid__badge">
      {badge}
    </div>
  );
};

export { GridBadge };